import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './responsive.css';
import './mobileOverflowFix.css';
import './acquisitionCrossPlatformAlignment.css';
import './valuationAuthFetch';
import './desktopHeaderSurfaceFix';
import './mobileMarketingNav';
import './homepageScreenshotRefresh';
import './homepageMessagingRefresh';
import './homepagePositioningEnhancement';
import './acquisitionROIEnhancement';
import './acquisitionRetailPerformanceEnhancement';
import './acquisitionIntelligenceEnhancement';
import './acquisitionTodayEnhancement';
import './acquisitionOSDashboardEnhancement';
import './acquisitionGroupEnhancement';
import './acquisitionWorkQueuesEnhancement';
import './serviceDriveIntakeEnhancement';
import './serviceDriveFeedEnhancement';
import './printPackAutoFillEnhancement';
import './printPackEnhancement';
import './printPackDeliveryEnhancement';
import './crmPrintPackBridge';
import './selectAllCheckboxEnhancement';
import './signatureRescueEnhancement';
import './acquisitionPilotEnhancement';
import './dealerSetupCenterEnhancement';
import './nextActionWorkflowEnhancement';
import './acquisitionUsabilitySimplification';
import './opportunityGuidedWorkspaceEnhancement';
import './unifiedPaperworkEnhancement';
import './interactiveAcquisitionOnboarding';
import './removeTradeInsEnhancement';
import './customerAccountCenteringEnhancement';
import './acquisitionUppercaseInputEnhancement';
import './quickCustomerSearchEnhancement';
import './acquisitionCompletionEnhancement';
import './acquisitionCloseoutEnhancement';
import App from './App';
import RuntimeErrorBoundary from './components/RuntimeErrorBoundary';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RuntimeErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </RuntimeErrorBoundary>
);

reportWebVitals();